var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJisuanxuanxing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_1162)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 2,
    width: 12,
    height: 12,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29167 11.5H6.41667V10.3333H5.25V9.45833H6.41667V8.29167H7.29167V9.45833H8.45833V10.3333H7.29167V11.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 11.0625H9.33333V10.1875H12.25V11.0625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 9.60417H9.33333V8.72917H12.25V9.60417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3125 6.36667H5.39583V5.49167H8.3125V6.36667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7917 6.57083L9.975 7.3875L9.3625 6.775L10.1792 5.92917L9.3625 5.1125L9.975 4.5L10.7917 5.31667L11.6083 4.5L12.2208 5.1125L11.4042 5.92917L12.2208 6.775L11.6083 7.3875L10.7917 6.57083Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_1162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJisuanxuanxing);
export default __webpack_public_path__ + "static/media/jisuanxuanxing.25976f9c4b6a1eb2942520044f247231.svg";
export { ForwardRef as ReactComponent };